import React from "react";
import Context from "../../../../../context";

import {
  CustomModal,
  CustomView,
  UserInformation,
} from "../../../../../components";
import "../index.scss";
import convertGregorianToJalali from "../../../../../utils/convertGregorianToJalali";
import ImageViewer from "../../../../../components/ImageViewer";
import { useTranslation } from "react-i18next";

const CompanyInformation = () => {
  const { showModal, setShowModal, selectedCompany } = React.useContext(
    Context.CompanyScreen
  );

  const selectedProvinceWithoutDuplicate =
    selectedCompany?.companyInformation?.province?.filter(
      (obj: any, index: number, self: any) =>
        index === self.findIndex((t: any) => t._id === obj._id)
    );

  const { t } = useTranslation();

  return (
    <section id="service-screen-show-user-information">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        minWidth={"35vw"}
        maxWidth={"50vw"}
        open={showModal === "SHOW_COMPANY_INFORMATION"}
        overlayClose
      >
        <CustomView.Container className="scroll-content">
          <UserInformation
            avatar={selectedCompany?.avatar}
            name={
              selectedCompany?.companyInformation?.companyName
                ? selectedCompany?.companyInformation?.companyName
                : selectedCompany?.name
            }
            phoneNumber={
              selectedCompany?.phoneNumber
                ? selectedCompany?.phoneNumber
                : selectedCompany?.telephone
            }
            isBlock={null}
          />
          <hr />
          <CustomView.Row className="form-column-row">
            {selectedCompany?.companyInformation?.province && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("province")} :</label>
                <p>
                  {selectedProvinceWithoutDuplicate?.map((item: any) =>
                    selectedProvinceWithoutDuplicate?.indexOf(item) !==
                    selectedProvinceWithoutDuplicate?.length - 1
                      ? item?.Name + " - "
                      : item?.Name + ""
                  )}
                </p>
              </CustomView.Column>
            )}
            {selectedCompany?.companyInformation?.city && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("city")} :</label>
                <p>
                  {selectedCompany?.companyInformation?.city?.map((item: any) =>
                    selectedCompany?.companyInformation?.city?.indexOf(item) !==
                    selectedCompany?.companyInformation?.city?.length - 1
                      ? item?.Name + " - "
                      : item?.Name + ""
                  )}
                </p>
              </CustomView.Column>
            )}
            {selectedCompany?.companyInformation?.address && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("address")} :</label>
                <p>{selectedCompany?.companyInformation?.address}</p>
              </CustomView.Column>
            )}
            {selectedCompany?.companyInformation?.superAgent?.firstName && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("superAgent")} :</label>
                <p style={{ direction: "ltr" }}>
                  {selectedCompany?.companyInformation?.superAgent?.firstName}{" "}
                  {selectedCompany?.companyInformation?.superAgent?.lastName}
                </p>
              </CustomView.Column>
            )}
            {selectedCompany?.companyInformation?.approved?.isApproved && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("status")} :</label>
                <p>
                  {selectedCompany?.companyInformation?.approved?.isApproved
                    ? t("approved")
                    : t("disApproved")}
                </p>
              </CustomView.Column>
            )}
            {selectedCompany?.companyInformation?.approved?.approvedAt && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("approveDate")} :</label>
                <p style={{ direction: "ltr" }}>
                  {convertGregorianToJalali(
                    selectedCompany?.companyInformation?.approved?.approvedAt
                  )}
                </p>
              </CustomView.Column>
            )}
            {selectedCompany?.superAgentSchoolInformation?.superAgentName && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("superAgent")} :</label>
                <p>
                  {selectedCompany?.superAgentSchoolInformation?.superAgentName}
                </p>
              </CustomView.Column>
            )}
            {selectedCompany?.financial?.kartNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("cardNumber")} :</label>
                <p>{selectedCompany?.financial?.kartNumber}</p>
              </CustomView.Column>
            )}
            {selectedCompany?.financial?.shabaNumber && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-values form-column"
              >
                <label className="form-label">{t("shabaNumber")} :</label>
                <p>{selectedCompany?.financial?.shabaNumber}</p>
              </CustomView.Column>
            )}{" "}
            {selectedCompany?.companyInformation?.documents
              ?.nationalCardFront && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-documents form-column"
              >
                <div>{t("nationalCardFrontImage")}</div>
                <ImageViewer
                  imageUrl={
                    selectedCompany?.companyInformation?.documents
                      ?.nationalCardFront
                  }
                />
              </CustomView.Column>
            )}{" "}
            {selectedCompany?.companyInformation?.documents
              ?.nationalCardBack && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-documents form-column"
              >
                <div>{t("nationalCardFrontImage")}</div>
                <ImageViewer
                  imageUrl={
                    selectedCompany?.companyInformation?.documents
                      ?.nationalCardBack
                  }
                />
              </CustomView.Column>
            )}{" "}
            {selectedCompany?.companyInformation?.documents?.companyLicence && (
              <CustomView.Column
                medium={5}
                small={12}
                large={5}
                className="form-documents form-column"
              >
                <div>{t("companyLicence")}</div>
                <ImageViewer
                  imageUrl={
                    selectedCompany?.companyInformation?.documents
                      ?.companyLicence
                  }
                />
              </CustomView.Column>
            )}
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default CompanyInformation;
